import { MessageBox } from 'element-ui';
import { baseUrl } from './env';
import router from '../router';

let status = 0;
// 当前ip
const url_type = window.location.host;
// 配置ip
// let  new_baseUrl = baseUrl;
// if(url_type == '172.20.28.50:81'){

async function http(url, data, type, method, token) {
  if (window.fetch && method === 'fetch') {
    const requestConfig = {
      'credentials': 'include',
      'method': type,
      'headers': {
        // 'Accept': 'application/json',
        'Content-Type': 'application/json',
        // 'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': token
      },
      'mode': 'cors',
      'cache': 'no-cache',
      'timeout': 5 * 60 * 1000
    };

    if (type === 'POST') {
      requestConfig.timeout = 5 * 60 * 1000;
      // console.log(requestConfig);
      Object.defineProperty(requestConfig, 'body', {
        'value': JSON.stringify(data)
      });
    }

    try {
      const response = await fetch(url, requestConfig);
      const responseJson = await response.json();

      if (responseJson.status === -1 && responseJson.msg) {
        responseJson.message = responseJson.msg;
      } else {
        status++;
        if (responseJson.error === 'invalid_token') {
          if (status === 1) {
            setTimeout(() => {
              if (window.location.href.indexOf('/login') === -1) {
                MessageBox.alert('登陆已过期，请重新登陆', '', {
                  'confirmButtonText': '确定',
                  'callback': () => {
                    status = 0;
                    // window.location.href = window.location.origin + "#/login";
                  }
                });
                router.replace('/login');
              }
            }, 1000);
          }
        } else {
          status = 0;
        }
      }
      return responseJson;
    } catch (error) {
      MessageBox.alert('网络请求错误，请稍后再试');
      throw new Error(error);
    }
  } else {
    return new Promise((resolve, reject) => {
      let requestObj;

      if (window.XMLHttpRequest) {
        requestObj = new XMLHttpRequest();
      } else {
        requestObj = new ActiveXObject();
      }

      let sendData = '';

      if (type == 'POST') {
        sendData = JSON.stringify(data);
      }
      requestObj.open(type, url, true);
      requestObj.setRequestHeader('Content-type', 'application/json');
      requestObj.setRequestHeader('Authorization', token);
      requestObj.send(sendData);
      requestObj.onreadystatechange = () => {
        if (requestObj.readyState == 4) {
          if (requestObj.status == 200) {
            let obj = requestObj.response;

            if (typeof obj !== 'object') {
              obj = JSON.parse(obj);
            }
            if (obj.state && obj.msg) {
              // 表明调用第三方接口出异常
              obj.status = obj.state;
              obj.message = obj.msg;
            }
            resolve(obj);
          } else {
            reject(requestObj);
          }
        }
      };
    });
  }
}

export default async (url = '', data = {}, type = 'GET', method = 'fetch') => {
  // console.log(url_type);
  let token;

  if (window.sessionStorage.getItem('token')) {
    token = window.sessionStorage.getItem('token');
  }
  // alert(url_type);
  // 判断是否存在
  if (url_type) {
    // 截取ip
    const ip = url_type.split(':')[0];
    // console.log(ip,'ip')

    if ('http://172.20.28.50:81'.indexOf(ip) != -1) {
      url = `http://172.20.28.50:81${url}`;
      debugger;
      // console.log(url,'url')
    } else {
      url = baseUrl + url;
    }
  } else {
    return;
  }
  type = type.toUpperCase();
  // console.log(url);

  if (type === 'GET') {
    let dataStr = ''; // 数据拼接字符串

    Object.keys(data).forEach(key => {
      dataStr += `${key}=${data[key]}&`;
    });

    if (dataStr !== '') {
      dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
      url = `${url}?${dataStr}`;
    }
  }

  if (token) {
    if (url.indexOf('?') === -1) {
      url += `?access_token=${token}`;
    } else {
      url += `&access_token=${token}`;
    }
  }
  let res;
  let i = 0;

  do {
    res = await http(url, data, type, method, token);
    i++;
  } while (res.error && res.error === 'invalid_token' && i < 3);
  return res;
};


